import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlansStatusComponent } from './plans-status.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    PlansStatusComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
  ], 
  exports: [
    PlansStatusComponent
  ]
})
export class PlansStatusModule { }
